import React, { useState } from 'react';
import {
  Button,
  Tooltip,
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
} from '@mui/material';
import Modal from '@mui/material/Modal';

const CourseManage = () => {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    batchId: '',
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const staticBatchData = [
    { id: 1, name: 'Batch A' },
    { id: 2, name: 'Batch B' },
    { id: 3, name: 'Batch C' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (formData.batchId) {
      setShowSuccessModal(true);
      setFormData({
        batchId: '',
      });
    } else {
      alert('Please select a batch');
    }
  };

  const handleReset = () => {
    setFormData({
      batchId: '',
    });
  };

  return (
    <Container sx={{ mt: 2 }}>
      <Box sx={{ mb: 2 }}>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
            <FormControl fullWidth sx={{ width: 300, maxWidth: '100%' }}>
              <InputLabel id="batch-label" sx={{ color: theme.palette.text.primary }}>
                Batch *
              </InputLabel>
              <Select
                labelId="batch-label"
                id="batch"
                name="batchId"
                value={formData.batchId}
                label="Batch *"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
                required
              >
                <MenuItem value="">
                  <em>Select a batch</em>
                </MenuItem>
                {staticBatchData.map((batch) => (
                  <MenuItem key={batch.id} value={batch.id}>
                    {batch.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mt:6 }}>
            <Tooltip
              title={!formData.batchId ? 'Select Batch' : ''}
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.batchId}
                >
                  SAVE
                </Button>
              </span>
            </Tooltip>
            <Button
              variant="contained"
              color="error"
              onClick={handleReset}
            >
              RESET
            </Button>
          </Box>
        </form>
      </Box>
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Typography variant="h6" color={theme.palette.text.primary}>
          No Record Found
        </Typography>
      </Box>

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Batch Saved ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Batch Saved Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => setShowSuccessModal(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default CourseManage;